// App root component
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import { Web3Provider } from "@/components/Web3Provider";
import FloatingChatButton from "@/components/FloatingChatButton";
import MFAGuard from "@/components/MFAGuard";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Transactions from "./pages/Transactions";
import Admin from "./pages/Admin";
import AIChat from "./pages/AIChat";
import WalletPage from "./pages/Wallet";
import MFASetup from "./pages/MFASetup";
import MFAVerify from "./pages/MFAVerify";
import NotFound from "./pages/NotFound";
import Profile from "./pages/Profile";

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1 } },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <Web3Provider>
      <TooltipProvider>
        <AuthProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <FloatingChatButton />
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/mfa-setup" element={<MFASetup />} />
              <Route path="/mfa-verify" element={<MFAVerify />} />
              <Route path="/dashboard" element={<MFAGuard><Dashboard /></MFAGuard>} />
              <Route path="/transactions" element={<MFAGuard><Transactions /></MFAGuard>} />
              <Route path="/wallet" element={<MFAGuard><WalletPage /></MFAGuard>} />
              <Route path="/admin" element={<MFAGuard><Admin /></MFAGuard>} />
              <Route path="/profile" element={<MFAGuard><Profile /></MFAGuard>} />
              <Route path="/chat" element={<AIChat />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </TooltipProvider>
    </Web3Provider>
  </QueryClientProvider>
);

export default App;
